// app/javascript/account/puzzle.js
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'jquery-ui/dist/jquery-ui.js';
import '../mobile/jquery.ui.touch-punch.min.js';

class DragPuzzle {
  /**
   * new DragPuzzle(min, max, [..images, mask, target])
   */
  constructor(min, max, imagesWithExtras) {
    this.min = min;
    this.max = max;

    // ---- Single-run guard (avoid duplicate render) ----
    const root = document.querySelector('.security-puzzle');
    if (!root) return;
    if (root.dataset.puzzleInit === '1') return;
    root.dataset.puzzleInit = '1';

    // ---- Split images vs (mask, target) ----
    const arr = (imagesWithExtras || []).slice();
    this.target = arr.pop(); // last
    this.mask   = arr.pop(); // second last
    this.images = arr;

    this.draggableEl = null;
    this.dragData = [];
    this.dragStartTime = 0;

    this.loadPuzzle();
  }

  evaluateDrag = () => {
    const duration   = performance.now() - this.dragStartTime;
    const eventCount = this.dragData.length;
    let distance = 0;
    for (let i = 1; i < this.dragData.length; i++) {
      const dx = this.dragData[i].x - this.dragData[i - 1].x;
      const dy = this.dragData[i].y - this.dragData[i - 1].y;
      distance += Math.hypot(dx, dy);
    }
    let straightness = 0;
    if (this.dragData.length > 1) {
      const a = this.dragData[0], b = this.dragData[this.dragData.length - 1];
      const chord = Math.hypot(b.x - a.x, b.y - a.y);
      straightness = chord > 0 ? distance / chord : 0;
    }
    const avgSpeed = duration > 0 ? distance / duration : 0;
    return { eventCount, duration, straightness, avgSpeed };
  };

  dropHandler = () => {
    const m = this.evaluateDrag();
    const looksHuman = m.eventCount >= 10 && m.duration >= 200 && m.straightness > 1.02;
    if (!looksHuman) { alert('Suspicious drag detected. Please try again.'); this.reset(); return; }

    $(this.draggableEl).draggable({ revert: false }).draggable('disable').css('opacity', '0');
    $('#puzzle-snaptarget').css('background', 'transparent');
    this.showCheckMark();

    setTimeout(() => {
      fetch('/registrations/sign_up_form')
        .then(r => r.text())
        .then(html => {
          document.querySelector('.security-puzzle').style.display = 'none';
          document.querySelector('.puzzle-success').style.display = 'none';
          document.getElementById('form-container').innerHTML = html;
          // Intercept the injected form so submits go through fetch().
          // This is what stops the "captcha loop": a failed signup swaps
          // ONLY #form-container instead of re-rendering the puzzle page.
          this.bindFormSubmit();
        })
        .catch(err => console.error('Failed to load sign-up form:', err));
    }, 2000);
  };

  // ---------------------------------------------------------------------------
  // Submit the injected sign-up form via fetch instead of a normal navigation.
  //
  //  - 422 (validation failure): the controller returns the form partial with
  //    errors. We replace ONLY #form-container's innerHTML and re-bind. The
  //    solved puzzle stays hidden/solved — no loop, errors visible in place.
  //  - 2xx redirect (success): follow it (Devise redirects to the post-signup
  //    path).
  //  - opaque/manual redirect: fall back to resp.url or reload.
  // ---------------------------------------------------------------------------
  bindFormSubmit = () => {
    const container = document.getElementById('form-container');
    if (!container) return;

    const form = container.querySelector('#sign-up-form') ||
                 container.querySelector('form');
    if (!form) return;

    // Guard against double-binding if bindFormSubmit runs again.
    if (form.dataset.fetchBound === '1') return;
    form.dataset.fetchBound = '1';

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('input[type="submit"], button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      const formData = new FormData(form);
      const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

      fetch(form.action, {
        method: (form.method || 'POST').toUpperCase(),
        body: formData,
        credentials: 'same-origin',
        redirect: 'manual',
        headers: {
          'Accept': 'application/json, text/html',
          'X-Requested-With': 'XMLHttpRequest',
          ...(csrf ? { 'X-CSRF-Token': csrf } : {})
        }
      })
        .then(async (resp) => {
          // Success: controller returns { location: "..." } as JSON. We
          // navigate the browser ourselves so the GET that consumes the
          // flash is performed by the BROWSER (not fetch), and the
          // "An email was sent..." notice survives to the Sign In page.
          const ctype = resp.headers.get('Content-Type') || '';
          if (resp.ok && ctype.indexOf('application/json') !== -1) {
            const data = await resp.json();
            if (data && data.location) {
              window.location.assign(data.location);
              return;
            }
          }

          // Validation failure: controller returns the form partial (422).
          if (resp.status === 422) {
            const html = await resp.text();
            container.innerHTML = html;
            if (submitBtn) submitBtn.disabled = false;
            // Re-bind the freshly injected form.
            this.bindFormSubmit();
            return;
          }

          // 2xx without JSON (unlikely now) — if the body looks like the
          // form partial, re-inject; otherwise reload.
          if (resp.ok) {
            const html = await resp.text();
            if (html && html.indexOf('sign-up-form') !== -1) {
              container.innerHTML = html;
              if (submitBtn) submitBtn.disabled = false;
              this.bindFormSubmit();
            } else {
              window.location.assign('/');
            }
            return;
          }

          // Any other status: re-enable and surface a generic message.
          if (submitBtn) submitBtn.disabled = false;
          console.error('Sign-up failed with status', resp.status);
        })
        .catch((err) => {
          if (submitBtn) submitBtn.disabled = false;
          console.error('Sign-up request error:', err);
        });
    });
  };

  showCheckMark = () => {
    $('.puzzle-success').html(`
      <svg class="puzzle-svg" viewBox="0 0 130.2 130.2" xmlns="http://www.w3.org/2000/svg">
        <circle class="puzzle-path circle" fill="none" stroke="#73AF55" stroke-width="6"
                stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <polyline class="puzzle-path check" fill="none" stroke="#73AF55" stroke-width="6"
                  stroke-linecap="round" stroke-miterlimit="10"
                  points="100.2,40.2 51.5,88.8 29.8,67.5"/>
      </svg>
    `);
  };

  loadPuzzle = () => {
    // Clean slate (in case reset() or HMR)
    $('.puzzle').empty();
    $('.puzzle-choices').empty();
    $('.puzzle-success').empty();

    // Choose exactly `max` unique images
    const pool = this.images.slice();
    const count = Math.max(1, Math.min(this.max, pool.length));
    const picks = [];
    while (picks.length < count && pool.length) {
      const idx = Math.floor(Math.random() * pool.length);
      picks.push(pool.splice(idx, 1)[0]);
    }

    const correctIndex   = Math.floor(Math.random() * count);     // 0..count-1
    const randPosition   = Math.floor(Math.random() * count) + 1; // 1..count
    const randImageIndex = correctIndex + 1;                       // 1-based

    // Large puzzle background
    $('.puzzle').css({
      backgroundImage: `url(${picks[correctIndex]})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '300px 100px'
    });

    // Slots
    for (let i = 1; i <= count; i++) {
      const slot = $('<div>').addClass('puzzle-piece');
      if (i === randPosition) {
        slot.attr('id', 'puzzle-snaptarget')
            .css({ backgroundImage: `url(${this.target})`, backgroundRepeat: 'no-repeat', backgroundSize: '100px 100px' });
      }
      $('.puzzle').append(slot);
    }

    // Draggables
    for (let i = 0; i < count; i++) {
      const draggable = $('<div>').addClass('puzzle-draggable ui-widget-content');
      const mask = $('<div>').addClass('puzzle-mask');
      const image = $('<img>');

      // apply local mask asset
      mask.css({
        WebkitMaskImage: `url(${this.mask})`,
        maskImage:       `url(${this.mask})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat:       'no-repeat'
      });

      if (i === correctIndex) {
        image.attr({ src: picks[correctIndex], width: 300, height: 100 })
             .css({ marginLeft: `-${(randPosition - 1) * 100}px`, display: 'block' });

        draggable.attr('id', `puzzle-draggable${randImageIndex}`);
        draggable.draggable({
          snap: '#puzzle-snaptarget',
          snapMode: 'inner',
          revert: true,
          zIndex: 3000,
          start: () => { this.dragData = []; this.dragStartTime = performance.now(); },
          drag:  (event) => this.dragData.push({ x: event.pageX, y: event.pageY, t: performance.now() })
        });

        this.draggableEl = draggable;
      } else {
        image.attr({ src: picks[i], width: 300, height: 100 })
             .css({ marginLeft: `-${Math.floor(Math.random() * count) * 100}px`, display: 'block' });

        draggable.attr('id', `puzzle-draggable${i + 1}`);
        draggable.draggable({ snap: '#none', snapMode: 'inner', revert: true, zIndex: 3000 });
      }

      mask.append(image);
      draggable.append(mask);
      $('.puzzle-choices').append(draggable);
    }

    // Accept only the correct piece
    $('#puzzle-snaptarget').droppable({
      drop: (event, ui) => {
        if (ui.draggable.attr('id') === `puzzle-draggable${randImageIndex}`) this.dropHandler();
      }
    });

    // Safety: ensure exactly `count` draggables exist
    const total = document.querySelectorAll('.puzzle-choices .puzzle-draggable').length;
    if (total !== count) {
      console.warn('Puzzle rendered unexpected count, correcting:', total, '→', count);
      this.reset();
    }
  };

  reset = () => {
    $('.puzzle').empty();
    $('.puzzle-choices').empty();
    $('.puzzle-success').empty();
    this.draggableEl = null;
    this.loadPuzzle();
  };
}

export default DragPuzzle;
